import { render, staticRenderFns } from "./Voip.vue?vue&type=template&id=ce1dd50c&scoped=true&"
import script from "./Voip.vue?vue&type=script&lang=js&"
export * from "./Voip.vue?vue&type=script&lang=js&"
import style0 from "./Voip.vue?vue&type=style&index=0&id=ce1dd50c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce1dd50c",
  null
  
)

export default component.exports